import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Import Gotham Medium font */
  @font-face {
    font-family: 'Gotham';
    src: url('/fonts/Gotham Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: block;
  }
  
  /* Import Gotham Bold font */
  @font-face {
    font-family: 'Gotham';
    src: url('/fonts/Gotham Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: block;
  }

  /* Fallback system fonts that look similar to Gotham */
  :root {
    --color-dark: #131313;
    --color-primary: #415e4e;
    --color-secondary: #c1c38f;
    --color-tertiary: #e0ddd1;
    --color-black: #000;
    --color-white: #fff;
    --font-primary: 'Montserrat', sans-serif;
    --font-secondary: 'Playfair Display', serif;
    --font-accent: 'Gotham', 'Arial Black', 'Helvetica Neue', sans-serif;
    --transition: all 0.3s ease;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: var(--font-primary);
    background-color: var(--color-dark);
    color: var(--color-tertiary);
    line-height: 1.6;
    overflow-x: hidden;
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: var(--transition);
  }

  button {
    cursor: pointer;
    font-family: var(--font-primary);
    transition: var(--transition);
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-secondary);
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 3.5rem;
  }

  h2 {
    font-size: 2.5rem;
  }

  h3 {
    font-size: 2rem;
  }

  p {
    margin-bottom: 1rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .section {
    padding: 5rem 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 3rem;
    position: relative;
  }

  .section-title::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: var(--color-secondary);
  }

  .btn {
    display: inline-block;
    padding: 0.8rem 2rem;
    background-color: var(--color-primary);
    color: var(--color-tertiary);
    border: none;
    border-radius: 4px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: var(--transition);
  }

  .btn:hover {
    background-color: var(--color-secondary);
    color: var(--color-dark);
  }

  .text-center {
    text-align: center;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }

    h2 {
      font-size: 2rem;
    }

    h3 {
      font-size: 1.5rem;
    }

    .section {
      padding: 3rem 0;
    }
  }
`;

export default GlobalStyles; 